import { FC } from 'react';
import { Form, Select} from 'antd';
import { Country } from '../../../types/country';
import { CountryDropdownContainerProps } from './country-dropdown-container';

export const CountryDropdown: FC<CountryDropdownContainerProps> = ({
  placeholder,
  style,
  showSearch,
  optionFilterProp,
  labelRender,
  countryData,
  selectedCitizenship,
  onChange,
  allCountryData,
  disabled,
  ...props // Spread operator to accept additional props
}) => {
  console.log('allCountryData', allCountryData);
  const handleOnChange = (value: string) => {
    if (onChange) {
      onChange(value);
    }
  }
  return (
    <>
    {props.isCitizenship ? (<Select
      placeholder={placeholder}
      style={style}
      showSearch={showSearch}
      optionFilterProp={optionFilterProp}
      labelRender={labelRender}
      onChange={onChange}
      {...props} // Pass additional props to the Select component
    >
      {(countryData || [])
        .filter((c) => !selectedCitizenship?.includes(c.countryCode))
        .map((item) => (
          <Select.Option key={item.countryCode} value={item.countryCode}>
            {item.countryName}
          </Select.Option>
        ))}
    </Select>) : props.isPrimaryEducation ? ( <Select
                style={style}
                placeholder="Country"
                onChange={onChange}
                showSearch
                optionFilterProp="children"
              >
                 {allCountryData?.map((item: Country) => (
          <Select.Option key={item.countryCode} value={item.countryCode}>
            {item.countryName}
          </Select.Option>
        ))}
              </Select>) : (  <Form.Item name={props.name} label={props.label ?? "Country"} 
    rules= {props.rules ?? []}
    >
      <Select
        style={style}
        placeholder="Country"
        onChange={(value) => handleOnChange(value)}
        showSearch
        optionFilterProp="children"
        disabled={disabled}
      >
        {allCountryData?.map((item: Country) => (
          <Select.Option key={item.countryCode} value={item.countryCode}>
            {item.countryName}
          </Select.Option>
        ))}
      </Select>
    </Form.Item>)}
    </>
    
  );
};